import {
  Checkbox,
  Drawer,
  FormControl,
  MenuItem,
  Select,
  Typography,
  Avatar,
  Button,
  Card,
  FormControlLabel,
  TextareaAutosize,
  Box,
  Popover,
  TextField,
  Tooltip,
} from "@mui/material";
import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Close } from "@mui/icons-material";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";

import ClientImg from "../../../assets/images/images-svg/client-large.svg";
import ProviderImg from "../../../assets/images/images-svg/provider-large.svg";
import { ReactComponent as ClipBoardIcon } from "../../../assets/images/images-svg/Clipboard.svg";
import { ReactComponent as NewsIcon } from "../../../assets/images/images-svg/Activity.svg";
import { ReactComponent as EmailIcon } from "../../../assets/images/images-svg/Email.svg";
import { ReactComponent as MessageIcon } from "../../../assets/images/images-svg/Message circle.svg";
import { MenuProps } from "src/constants/providers";
import {
  GetProviderById,
  updateProviderEmploymentById,
} from "src/service/provider.service";
import {
  getClientById,
  updateClientWithBasicDetails,
} from "src/service/client.service";
import { batch } from "react-redux";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "src/redux/store";
import { setResponseValue } from "src/redux/features/api-response/api-response";
import { moveToAnotherBoard } from "src/service/common.service";
import {
  getAllCustomBoard,
  setBoardScrollPosition,
} from "src/redux/features/custom-board/custom-board-slice";
import { getClientBoards } from "src/redux/features/client-main/client-board-slice";
import { getProviderBoards } from "src/redux/features/providers-main/provider-board-slice";
import "./activityCenter.scss";
import {
  deleteMessage,
  getMessageByEntityId,
  postCreateMessage,
  updateMessage,
} from "src/service/message.service";
import { dateToFromNowDaily } from "src/helpers/reverse-list/reverse-list";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  GetActiveMailboxProvider,
  GetAllEmails,
  GetEmailById,
  UpdateEmailStatus,
  resetAllEmails,
} from "src/redux/features/mailBox/mailbox-slice";
import { useUser } from "@descope/react-sdk";
import { formatTimeStampDate, getInitials } from "src/constants/common";
import EditIcon from "../../../assets/images/images-png/EditSquare.png";
import SearchIcon from "@mui/icons-material/Search";
import { IMail } from "src/types/mail";
import { Link } from "react-router-dom";
import { ICurrentPlan } from "src/types/product";
import { getTenantPlan } from "src/redux/features/plan-billing/plan-billing-slice";
import SmsView from "./SmsView";
import { clearSmsHistory } from "src/redux/features/messages/message-slice";

interface IActivityCenter {
  closeCommand: Dispatch<SetStateAction<boolean>>;
  setOpenEmailView: Dispatch<SetStateAction<boolean>>;
  setComposeEmailModal: Dispatch<SetStateAction<boolean>>;
  setComposeToEmail: Dispatch<SetStateAction<string>>;
  cardData: {
    boardName: string;
    stages: any[];
    card: any;
  };
  selectedBoard: {
    id: string;
    type: string;
    index?: number;
  };
}

const ActivityCenter: React.FC<IActivityCenter> = ({
  closeCommand,
  cardData,
  selectedBoard,
  setOpenEmailView,
  setComposeEmailModal,
  setComposeToEmail
}) => {
  //#region varible region
  // const { user } = useUser();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const tabs = [
    { name: "Stages", icon: <ClipBoardIcon /> },
    { name: "Emails", icon: <EmailIcon /> },
    { name: "Texts", icon: <MessageIcon /> },
    { name: "News", icon: <NewsIcon /> },
  ];
  //handle current stages
  const [currentStage, setCurrentStage] = useState<string>("");

  //stores selected tab
  const [selectedTab, setSelectedTab] = useState<string>("Stages");

  //handle stage checklist
  const [stageChecklist, setStageChecklist] = useState<any[]>([]);

  //handle current check list
  const [checklistHistory, setChecklistHistory] = useState<string[]>([]);

  //handle current Entity
  const [currentEntity, setCurrentEntity] = useState<any>();

  //client/provider contact -> email
  const [entityEmail, setEntityEmail] = useState<string>("");

  //handle comments
  const [comments, setComments] = useState<any[]>([]);

  //handle message
  const [message, setMessage] = useState<string>("");

  //handle message Id
  const [messageId, setMessageId] = useState<string>("");

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  //handles search filter
  const [searchText, setSearchText] = useState<string>("");
  const [debouncedSearchText, setDebouncedSearchText] = useState<string>("");

  //if true Popover component show
  const open = Boolean(anchorEl);

  const scrollPosition = useAppSelector(
    (state) => state.boardSlice.scrollPosition
  );

  const entityEmails = useAppSelector((state) => state.mailBoxSlice.allEmails);
  const mailBoxAuthData: any = useAppSelector(
    (state) => state.mailBoxSlice.mailBoxAuthData
  );
  const currentPlan = useAppSelector<ICurrentPlan>(
    (state) => state.planBillingSlice.currentPlan
  );
  const orgData = useAppSelector(
    (state) => state.organizationSlice.orgData
  );

  //#engregion
  const handleClose = () => {
    setAnchorEl(null);
  };

  const saperator = (text: string) => {
    return (
      <div>
        {text.split("\n").map((item: string) => {
          return <div key={item}>{item}</div>;
        })}
      </div>
    );
  };
  //#region functions region
  const getClient = async (id: string) => {
    const { data } = await getClientById(id);
    if (data) {
      setCurrentEntity(data.clientBasicDetails);
      setEntityEmail(data.clientContactDetails.email);
    }
  };

  //get Provider data
  const getProvider = async (id: string) => {
    const { data } = await GetProviderById(id);
    if (data) {
      setCurrentEntity(data.employmentDetails);
      setEntityEmail(data.contactDetails.email);
    }
  };

  const isChecklistUpdated = (entityChecklist: string[]) => {
    return (
      entityChecklist?.length !== checklistHistory?.length ||
      entityChecklist.some((item) => !checklistHistory.includes(item))
    );
  };

  const handleUpdateStageChanges = async () => {
    const isUpdated = isChecklistUpdated(currentEntity.checklistHistory);
    if (isUpdated && cardData.card.entityType === "Client") {
      const data = await updateClientWithBasicDetails({
        ...currentEntity,
        checklistHistory: checklistHistory,
      });
      dispatch(setResponseValue({ name: "success", value: true }));
      dispatch(setResponseValue({ name: "message", value: data?.message }));
    } else if (isUpdated && cardData.card.entityType === "Provider") {
      const data = await updateProviderEmploymentById(currentEntity?.id, {
        ...currentEntity,
        checklistHistory: checklistHistory,
      });
      dispatch(setResponseValue({ name: "success", value: true }));
      dispatch(setResponseValue({ name: "message", value: data?.message }));
    }
    if (cardData.card.stageId !== currentStage) {
      dispatch(setResponseValue({ name: "pending", value: true }));
      await moveToAnotherBoard(
        cardData.card.stageId,
        currentStage,
        cardData.card.id,
        0
        // "Client"
      );
      if (cardData.boardName === "Intake Board") {
        dispatch(getClientBoards({ useLoader: false }));
      } else if (cardData.boardName === "OnBoarding Board") {
        dispatch(getProviderBoards({ useLoader: false }));
      } else {
        dispatch(getAllCustomBoard());
      }
      dispatch(setResponseValue({ name: "pending", value: false }));
    }
  };

  const handleRedirect = () => {
    if (selectedBoard) {
      const [boardTemplate] = document.getElementsByClassName("boardTemplate");
      const data = {
        boardId: selectedBoard.id,
        scrollLeft: boardTemplate.scrollLeft,
        scrollTop: boardTemplate.scrollTop,
      };
      const updatedScrollPosition = scrollPosition.map((item) =>
        item.boardId === selectedBoard.id
          ? {
              ...item,
              scrollLeft: boardTemplate.scrollLeft,
              scrollTop: boardTemplate.scrollTop,
            }
          : item
      );
      if (!scrollPosition.some((item) => item.boardId === selectedBoard.id)) {
        updatedScrollPosition.push(data);
      }
      dispatch(setBoardScrollPosition(updatedScrollPosition));
    }
    if (cardData.card.entityType === "Provider") {
      navigate(`/provider/${cardData.card.entityId}`);
    } else {
      navigate(`/client/${cardData.card.entityId}`);
    }
  };

  //create new message
  const createNewMessage = async () => {
    try {
      if (!message) return;
      const payload = {
        subject: "internal message",
        message,
        whoCanView: ["admin", "parent"],
        // type: category.toLowerCase(),
        type: "internal",
        from: "",
        entityType: cardData.card.entityType,
      };

      const { data } = await postCreateMessage(payload, cardData.card.entityId);
      if (data) {
        setComments([data, ...comments]);
      }
    } catch (e) {
      console.log(e);
    }
    setMessage("");
  };

  //updated message
  const updateCurrentMessage = async () => {
    try {
      if (!message) return;

      const data = await updateMessage(messageId, message);
      if (data.status) {
        setComments(
          comments.map((msg) => {
            if (msg.id === messageId) {
              return { ...msg, message };
            } else {
              return msg;
            }
          })
        );
        setMessageId("");
      }
    } catch (e) {
      console.log(e);
    }
    setMessage("");
  };

  //delete message
  const deleteMessageHandle = async () => {
    if (!messageId) return;

    const data = await deleteMessage(messageId);
    if (data.status) {
      setComments(comments.filter((msg) => msg.id !== messageId));
    }
    setMessageId("");
    setAnchorEl(null);
  };

  const getMessageOfUser = async () => {
    const message = (await getMessageByEntityId(cardData.card.entityId)).data;
    setComments(
      message.allUserMessage
        .filter((item) => item.type === "internal")
        .sort(
          (a, b) =>
            new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
        )
    );
  };

  function useDebounce(cb: (...args: any[]) => void, delay: number) {
    const timeoutId = useRef<ReturnType<typeof setTimeout>>();

    return function (...args: any[]) {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
      timeoutId.current = setTimeout(() => cb(...args), delay);
    };
  }

  const debouncedChange = useDebounce((inputValue: string) => {
    setDebouncedSearchText(inputValue);
  }, 500);

  const handleEmailSearch = (entityEmails: IMail[]) => {
	return entityEmails
		.filter((item) =>
			item.subject.toLowerCase().includes(debouncedSearchText.toLowerCase()),
		)
		.sort((a, b) => {
			if (a.starred && !b.starred) return -1;
			if (!a.starred && b.starred) return 1;
			return (
				new Date(b.date || 0).getTime() - new Date(a.date || 0).getTime()
			);
		});
};

const handleStarToggle = async (emailId: string, currentStarred: boolean) => {
	if (mailBoxAuthData.email) {
		try {
			dispatch(
				UpdateEmailStatus({
					email: mailBoxAuthData.email,
					mailId: emailId,
					starred: !currentStarred,
				}),
			).unwrap();
			dispatch(
				GetAllEmails({
					userEmail: mailBoxAuthData.email,
					pageToken: "",
					folderId: "",
					searchEmails: entityEmail,
				}),
			);
		} catch (error) {
			console.error("Failed to update star status:", error);
			dispatch(setResponseValue({ name: "error", value: true }));
			dispatch(
				setResponseValue({
					name: "message",
					value: "Failed to update email star status",
				}),
			);
		}
	}
};
  //#endregion

  //#region useEffect region

  useEffect(() => {
    if (!mailBoxAuthData) dispatch(GetActiveMailboxProvider());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mailBoxAuthData]);

  useEffect(() => {
    if (cardData.card.entityType === "Client") {
      getClient(cardData.card.entityId);
    } else {
      getProvider(cardData.card.entityId);
    }
  }, [cardData]);

  useEffect(() => {
    let initStage: any;
    if (cardData) {
      initStage = cardData.stages.find(
        (stg) => stg.id === cardData.card.stageId
      );
    }
    if (initStage) {
      batch(() => {
        setCurrentStage(initStage.id);
        setStageChecklist(initStage.checkList);
      });
    }
    if (currentEntity) {
      setChecklistHistory(currentEntity?.checklistHistory);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentEntity?.intakeStage,
    currentEntity?.onBoardingStage,
    cardData?.card?.stageId,
    currentEntity?.checklistHistory,
  ]);

  useEffect(() => {
    if (currentEntity) {
      getMessageOfUser();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comments?.length, currentEntity]);

  useEffect(() => {
    if (selectedTab === "Emails" && mailBoxAuthData && entityEmail) {
      dispatch(
        GetAllEmails({
          userEmail: mailBoxAuthData?.email,
          pageToken: "",
          folderId: "",
          searchEmails: entityEmail,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab, entityEmail]);

  //get current plan
  useEffect(() => {
    dispatch(getTenantPlan());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log("currentPlan", currentPlan);
  // console.log("selectedTab", selectedTab);
  //#endregion
  return (
    <div className="activityCenter">
      <Drawer anchor={"right"} open={true} className="activityCenter__Drawer">
        <div className="activityCenter__content">
          <div className="activityCenter__header">
            <div className="activityCenter__userDetails">
              <span className="activityCenter__userDetails-pic">
                <img
                  src={
                    cardData.card.entityType === "Client"
                      ? currentEntity?.clientProfile?.url || ClientImg
                      : currentEntity?.providerProfile?.url || ProviderImg
                  }
                  alt=""
                />
              </span>
              <Typography className="activityCenter__userDetails-title">
                {cardData.card.cardTitle}
              </Typography>
              <OpenInNewIcon
                color="primary"
                onClick={handleRedirect}
                className="activityCenter icons"
              />
            </div>
            <div
              onClick={() => {
                dispatch(resetAllEmails());
                dispatch(clearSmsHistory());
                closeCommand(false);
              }}
            >
              <Close className="activityCenter icons" />
            </div>
          </div>

          <div className="activityCenter__tabs">
            {tabs.map((item, index) => (
              <div
                key={index}
                className={`activityCenter__tabs-tab ${
                  selectedTab === item.name ? "active" : ""
                }`}
                onClick={() => setSelectedTab(item.name)}
              >
                {item.icon} {item.name}
              </div>
            ))}
          </div>
          <div className="activityCenter__tabDetail">
            {/* Tab - Stages */}
            {selectedTab === "Stages" && (
              <div className="activityCenter__stageDetail">
                <div className="activityCenter__stageDetail-boardTitle">
                  Board: {cardData.boardName}
                </div>
                <div className="activityCenter__stageDetail-dropDown">
                  <Typography className="activityCenter__subtitle">
                    Stage
                  </Typography>
                  <FormControl sx={{ m: 1, minWidth: 120, width: "100%" }}>
                    <Select
                      id="demo-multiple-name"
                      value={currentStage}
                      onChange={(e) => setCurrentStage(e.target.value)}
                      MenuProps={MenuProps}
                    >
                      {cardData.stages.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.stageName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
                <Typography className="activityCenter__subtitle">
                  Checklist
                </Typography>

                <div className="activityCenter__stageDetail-checklist">
                  {stageChecklist?.length > 0 ? (
                    stageChecklist?.map((item) => {
                      return (
                        <FormControlLabel
                          className="activityCenter__stageDetail-checklistItem"
                          label={item}
                          control={
                            <Checkbox
                              checked={checklistHistory?.includes(item)}
                              onClick={() => {
                                if (checklistHistory?.includes(item)) {
                                  setChecklistHistory((list) =>
                                    list.filter((element) => element !== item)
                                  );
                                } else {
                                  setChecklistHistory((list) => [
                                    item,
                                    ...list,
                                  ]);
                                }
                              }}
                            />
                          }
                        />
                      );
                    })
                  ) : (
                    <Typography>No Checklist found.</Typography>
                  )}
                </div>

                <div className="activityCenter__saveButton">
                  <Button
                    variant="contained"
                    onClick={handleUpdateStageChanges}
                  >
                    Save
                  </Button>
                </div>
              </div>
            )}

            {/* Email section */}
            {selectedTab === "Emails" && (
              <div className="activityCenter__emails">
                <div className="activityCenter__emails-header emailList">
                  <Typography className="activityCenter__subtitle ">
                    Emails
                  </Typography>
                  <SearchIcon className="search-icon" color="primary" />
                  <TextField
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      debouncedChange(e.target.value);
                    }}
                    id="outlined-basic"
                    label="search emails"
                    variant="outlined"
                    className="search-filter"
                    fullWidth
                    size="small"
                  />
                </div>
                {!mailBoxAuthData || !currentPlan?.addons.mailbox?.priceId ? (
                  <div
                    className="auth-msgContainer"
                    style={{ textAlign: "left" }}
                  >
                    <Typography
                      className="auth-msg"
                      sx={{ fontSize: "1.1rem", textAlign: "left" }}
                    >
                      To activate mailbox:
                      <ol
                        style={{
                          margin: "20px 0",
                          paddingLeft: "25px",
                          lineHeight: "2",
                          fontSize: "1.1rem",
                          textAlign: "left",
                        }}
                      >
                        <li style={{ textAlign: "left" }}>
                          Go to{" "}
                          <Link to="/my-plan" className="link">
                            Billing
                          </Link>{" "}
                          menu to purchase the mailbox add-on.
                        </li>
                        <li style={{ marginTop: "15px", textAlign: "left" }}>
                          Go to{" "}
                          <Link to="/app-integrations" className="link">
                            App Integration
                          </Link>{" "}
                          menu to connect your Google or Outlook email.
                        </li>
                      </ol>
                    </Typography>
                  </div>
                ) : (
                  <div className="activityCenter__emails-cardContainer">
                    <Button
                      variant="contained"
                      className="compose-button"
                      onClick={() => {
                        closeCommand(false);
                        setComposeEmailModal(true);
                        setComposeToEmail(entityEmail);
                        dispatch(resetAllEmails());
                      }}
                    >
                      <img src={EditIcon} alt="" />
                      {/* <Typography>Compose</Typography> */}
                    </Button>
                    <div className="activityCenter__emails-allEmails">
                      {handleEmailSearch(entityEmails).map((item) => (
                    <Tooltip title="Tap to open" placement="top" arrow>
					<div
					  className="activityCenter__emails-emailCard"
					  onClick={() => {
						if (mailBoxAuthData.email) {
						  dispatch(
							GetEmailById({
							  userEmail: mailBoxAuthData.email,
							  emailId: item.id,
							})
						  );
						  dispatch(
							GetAllEmails({
							  userEmail: mailBoxAuthData.email,
							  pageToken: "",
							  threadId: item?.threadId,
							})
						  );
						  setOpenEmailView(true); // open email view
						  closeCommand(false); // close activity center
						}
					  }}
					  style={{ cursor: "pointer" }}
					>
					  <div className="activityCenter__emails-fromEmail">
						<Checkbox
						  checked={item.starred}
						  icon={<StarBorderIcon />}
						  checkedIcon={<StarIcon className="fav-filled" />}
						  onClick={(e) => e.stopPropagation()} 
						  onChange={() => handleStarToggle(item.id, item.starred)} 
						/>
						<Avatar
						  sx={{
							bgcolor: "#096dd9",
							color: "white",
							fontSize: "16px",
							height: "32px",
							width: "32px",
						  }}
						>
						  {item.from[0].name ? getInitials(item?.from[0]?.name) : "UK"}
						</Avatar>
						<Typography className="activityCenter__emails-email">
						  {item?.from[0]?.name || item.from[0].email}
						</Typography>
					  </div>
					  <div className="activityCenter__flex">
						<Typography className="activityCenter__emails-subject">
						  {item.subject}
						</Typography>
						<Typography className="activityCenter__emails-date">
						  {item?.date ? formatTimeStampDate(item?.date, "DetailsView") : ""}
						</Typography>
					  </div>
					  {item?.logs?.length > 0 && (
						<Card className="activityCenter__track status">
						  {item?.logs[0]}
						</Card>
					  )}
					  <Typography className="activityCenter__emails-body">
						{item.snippet}
					  </Typography>
					</div>
				  </Tooltip>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Text section */}
            {selectedTab === "Texts" && (
              <div className="activityCenter__texts">
                {!currentPlan?.addons.sms?.priceId || !orgData?.orgPhone ? (
                  <div
                    className="auth-msgContainer"
                    style={{ textAlign: "left" }}
                  >
                    <Typography
                      className="auth-msg"
                      sx={{ fontSize: "2.1rem", textAlign: "left" }}
                    >
                      SMS Setup Requirements
                      <ul
                        style={{
                          margin: "20px 0",
                          paddingLeft: "25px",
                          lineHeight: "2",
                          fontSize: "1.1rem",
                          textAlign: "left",
                        }}
                      >
                        <li style={{ textAlign: "left" }}>
                          1. SMS Subscription:{" "}
                          {currentPlan?.addons.sms?.priceId
                            ? "✅ Complete"
                            : "❌ Please Go to"}{" "}
                          {!currentPlan?.addons.sms?.priceId && (
                            <Link to="/my-plan" className="link">
                              Billing
                            </Link>
                          )}
                        </li>
                        <li style={{ textAlign: "left" }}>
                          2. Integration Setup: Go to{" "}
                          <Link to="/app-integrations" className="link">
                            Integration
                          </Link>{" "}
                          and complete Integration Request Form
                        </li>
                        <li style={{ textAlign: "left" }}>
                          3. Org Phone Setup:{" "}
                          {orgData?.orgPhone
                            ? "✅ Complete"
                            : "❌ Configure at"}{" "}
                          {!orgData?.orgPhone && (
                            <Link to="/company-profile" className="link">
                              Organization Settings
                            </Link>
                          )}
                        </li>
                      </ul>
                    </Typography>
                  </div>
                ) : (
                  <div>
                    <SmsView
                      entityId={cardData.card.entityId}
                      entityType={cardData.card.entityType}
                    />
                  </div>
                )}
              </div>
            )}

            {/* News section */}
            {selectedTab === "News" && (
              <div className="activityCenter__news">
                <Typography className="activityCenter__subtitle ">
                  News
                </Typography>
                <div>
                  <Box className="commentForm">
                    <TextareaAutosize
                      value={message}
                      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                        setMessage(e.target.value)
                      }
                      placeholder="Leave a notice..."
                      minRows={2}
                    />
                    <Button
                      onClick={
                        messageId ? updateCurrentMessage : createNewMessage
                      }
                      variant="contained"
                      className="button"
                    >
                      {messageId ? "Update Notice" : "Add Notice"}
                    </Button>
                  </Box>
                  <Box className="commentListBox">
                    {comments.map((comment: any) => {
                      return (
                        <Box className="commentListItem" key={comment.id}>
                          <Box className="commentListItem__user">
                            <span className="commentListItem__user-img">
                              <img
                                src={
                                  comment.fromUser?.profilePictureUrl
                                    ? comment.fromUser?.profilePictureUrl
                                    : ClientImg
                                }
                                className="userSmallCircle"
                                alt=""
                              />
                            </span>
                            <div className="commentListItem__user-info">
                              <div
                                className="commentListItem__user-heading"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <div>
                                  <h5 className="commentListItem__user-name">
                                    {comment.fromUser?.firstName
                                      ? comment.fromUser?.firstName +
                                        " " +
                                        comment.fromUser?.lastName
                                      : comment.fromName}
                                  </h5>
                                  <h6 className="commentListItem__user-time">
                                    <span>
                                      {dateToFromNowDaily(comment.createdOn)}
                                    </span>
                                  </h6>
                                </div>
                                <MoreVertIcon
                                  sx={{ cursor: "pointer" }}
                                  onClick={({
                                    currentTarget,
                                  }: {
                                    currentTarget: any;
                                  }) => {
                                    setMessageId(comment.id);
                                    setAnchorEl(currentTarget);
                                  }}
                                />
                              </div>
                              <p className="commentListItem__user-comment">
                                {saperator(comment.message)}
                              </p>
                            </div>
                            <Popover
                              open={open}
                              anchorEl={anchorEl}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                            >
                              <ul className="popoverLinkList">
                                <li
                                  onClick={() => {
                                    const current = comments.find(
                                      (msg) => msg.id === messageId
                                    );
                                    setMessage(current.message);
                                    setAnchorEl(null);
                                  }}
                                >
                                  Edit
                                </li>
                                <li onClick={deleteMessageHandle}>Delete</li>
                              </ul>
                            </Popover>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>
                </div>
              </div>
            )}

            {/* Email section */}
            {/* {selectedTab === "Email" && (
              <div className="activityCenter__emails">
                <div className="activityCenter__emails-header emailList">
                  <Typography className="activityCenter__subtitle ">
                    Emails
                  </Typography>
                  <SearchIcon className="search-icon" color="primary" />
                  <TextField
                    value={searchText}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                      debouncedChange(e.target.value);
                    }}
                    id="outlined-basic"
                    label="search emails"
                    variant="outlined"
                    className="search-filter"
                    fullWidth
                    size="small"
                  />
                </div>
                {!mailBoxAuthData ? (
                  <Typography>Please Connect Mailbox.</Typography>
                ) : (
                  <div className="activityCenter__emails-cardContainer">
                    <Button
                      variant="contained"
                      className="compose-button"
                      onClick={() => {
                        closeCommand(false);
                        setComposeEmailModal(true);
                        dispatch(resetAllEmails());
                      }}
                    >
                      <img src={EditIcon} alt="" />
                    </Button>
                    <div className="activityCenter__emails-allEmails">
                      {handleEmailSearch(entityEmails).map((item) => (
                        <div
                          className="activityCenter__emails-emailCard"
                          onClick={() => {
                            if (user?.email) {
                              dispatch(
                                GetEmailById({
                                  userEmail: user?.email,
                                  emailId: item.id,
                                })
                              );
                              dispatch(
                                GetAllEmails({
                                  userEmail: user.email,
                                  pageToken: "",
                                  threadId: item?.threadId,
                                })
                              );
                              setOpenEmailView(true); //open email view
                              closeCommand(false); //close activity center
                            }
                          }}
                        >
                          <div className="activityCenter__emails-fromEmail">
                            <Checkbox
                              checked={item.starred}
                              icon={<StarBorderIcon />} // Empty star
                              checkedIcon={<StarIcon className="fav-filled" />} // Filled star
                            />
                            <Avatar
                              sx={{
                                bgcolor: "#096dd9",
                                color: "white",
                                fontSize: "16px",
                                height: "32px",
                                width: "32px",
                              }}
                            >
                              {item.from[0].name
                                ? getInitials(item?.from[0]?.name)
                                : "UK"}
                            </Avatar>
                            <Typography className="activityCenter__emails-email">
                              {item?.from[0]?.name || item.from[0].email}
                            </Typography>
                          </div>
                          <div className="activityCenter__flex">
                            <Typography className="activityCenter__emails-subject">
                              {item.subject}
                            </Typography>
                            <Typography className="activityCenter__emails-date">
                              {formatTimeStampDate(item?.date!, "DetailsView")}
                            </Typography>
                          </div>

                          {item?.logs.length > 0 && (
                            <Card className="activityCenter__track status">
                              {item?.logs[0]}
                            </Card>
                          )}
                          <Typography className="activityCenter__emails-body">
                            {item.snippet}
                          </Typography>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )} */}
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default ActivityCenter;
